//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../Routing/Routing.SelectISegment.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
let d=[[[0,"EqualSegmentsOption",1,0],[0,"ReverseSubdividePoint",1,0],[1,"Segment",0,"Routing.SelectISegment",0],[1,"SubdivideArcLength",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"SubdivideEndPercentage",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"SubdivideNumSegments",1,0],[1,"SubdividePoint",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"SubdivideStartPercentage",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"Type",1,0]],[[["createTangency","addPoints"],"SetSplineSettings",{},2,0],[["createTangency","createPoints"],"GetSplineSettings",{},0,0],[["createTangency","addPoints","addFixConstraint"],"SetSplineSettings1",{},3,0],[["createTangency","createPoints","addFixConstraint"],"GetSplineSettings1",{},0,0]],[]];
SPLM.Routing.SubdivideSegmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.SubdivideSegmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.SubdivideSegmentBuilder.Types = Object.freeze({
    "AtPoint" : "AtPoint", "EqualSegments" : "EqualSegments", "ArcLengthSegments" : "ArcLengthSegments"});

SPLM.Routing.SubdivideSegmentBuilder.EqualSegmentsMethod = Object.freeze({
    "EqualArcLength" : "EqualArcLength", "EqualParameter" : "EqualParameter"});

export default SPLM;